/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Namespaces } from '../../../i18n';

export const getLabelKey = (key: string, label?: boolean) =>
  label ? `${Namespaces.General}:jira_support.labels.${key}` : `${Namespaces.General}:jira_support.${key}`;
